import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { PapeisTrabalhoFormComponent } from 'src/app/pages/papeis-trabalho-form/papeis-trabalho-form.component';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';

@Injectable()
export class PapeisTrabalhoGuard implements CanDeactivate<PapeisTrabalhoFormComponent> {
  canDeactivate(component: PapeisTrabalhoFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}

